function validateStringNumber(value) {
  if (value) {
    return /^[0-9, ]+$/.test(value);
  }
  return true;
}

export { validateStringNumber };
//# sourceMappingURL=validation.js.map
